import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

interface Props {
	children: React.ReactNode;
}

const ErrorBoundaryProvider: React.FC<Props> = ({ children }) => {
	const navigate = useNavigate();
	const location = useLocation();

	const handleGoBack = () => {
		if (window.history.length > 1) {
			navigate(-1);
		} else {
			navigate("/view/");
		}
	};

	return (
		<ErrorBoundary goBack={handleGoBack} location={location}>
			{children}
		</ErrorBoundary>
	);
};

export default ErrorBoundaryProvider;
